(function () {
  "use strict";

  let openGuiaTallasModal = null;

  window.inyectarYAlzarModalGuiaTallas = function () {
    if (typeof openGuiaTallasModal === "function") {
      openGuiaTallasModal();
      return;
    }

    document.documentElement.dataset.gtOpenPending = "true";
  };

  if (!document.documentElement.dataset.gtClickBound) {
    document.documentElement.dataset.gtClickBound = "true";
    document.addEventListener(
      "click",
      (event) => {
        const trigger = event.target.closest("[data-guia-tallas-open], .guia-tallas-btn-tradicional");
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();
        window.inyectarYAlzarModalGuiaTallas();
      },
      true
    );
  }

  const state = {
    step: 1,
    complexion: "normal",
    selectedFit: "regular",
    tallaRegular: "",
    tallaRelgada: "",
    tallaUnica: "",
    tipo: "",
    hasComplexion: false,
    totalSteps: 2,
    config: {},
  };

  function getConfig() {
    const el = document.getElementById("gt-product-config");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch {
      return {};
    }
  }

  function $(id) {
    return document.getElementById(id);
  }

  function lockBody(lock) {
    document.body.classList.toggle("gt-modal-open", lock);
  }

  function portalModalsToBody() {
    const ids = ["gt-product-config", "guia-tallas-modal", "guia-tallas-tabla-modal", "guia-tradicional-modal"];
    ids.forEach((id) => {
      const el = $(id);
      if (el && el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  function openModal(id) {
    const modal = $(id);
    if (!modal) return;
    modal.classList.add("is-open");
    lockBody(true);
  }

  function closeModal(id) {
    const modal = $(id);
    if (!modal) return;
    modal.classList.remove("is-open");
    if (!document.querySelector(".gt-modal.is-open")) {
      lockBody(false);
    }
  }

  function updateProgress() {
    const modal = $("guia-tallas-modal");
    if (!modal) return;
    const segs = modal.querySelectorAll(".gt-progress__seg");
    const logicalStep = state.hasComplexion ? state.step : state.step === 3 ? 2 : 1;
    segs.forEach((seg, i) => {
      seg.classList.toggle("is-done", i < logicalStep);
      seg.classList.toggle("is-active", i === logicalStep - 1);
    });
  }

  const WIZARD_TITLES = {
    step1and2: "Encuentra tu talla",
    step3: "Recomendados",
  };

  function updateModalTitle(step) {
    const title = $("gt-wizard-title");
    const modal = $("guia-tallas-modal");
    if (!title || !modal) return;
    title.textContent = step === 3 ? WIZARD_TITLES.step3 : WIZARD_TITLES.step1and2;
    modal.classList.toggle("gt-wizard--step-3", step === 3);
    modal.classList.toggle("gt-wizard--step-2", step === 2);
    modal.classList.toggle("gt-wizard--step-1", step === 1);
  }

  function showStep(step) {
    state.step = step;
    const modal = $("guia-tallas-modal");
    if (!modal) return;
    modal.querySelectorAll(".gt-step").forEach((el) => {
      el.classList.toggle("is-active", Number(el.dataset.step) === step);
    });
    updateModalTitle(step);
    updateProgress();

    const panel = modal.querySelector(".gt-modal__panel");
    if (panel) panel.scrollTop = 0;
  }

  function resetWizard() {
    state.step = 1;
    state.complexion = "normal";
    state.selectedFit = "regular";
    const altura = $("gt-altura");
    const peso = $("gt-peso");
    if (altura) altura.value = "";
    if (peso) peso.value = "";
    const err = $("gt-error");
    if (err) err.classList.remove("is-visible");
    document.querySelectorAll(".gt-complexion-card").forEach((card, i) => {
      card.classList.toggle("is-selected", i === 0);
      const input = card.querySelector("input");
      if (input) input.checked = i === 0;
    });
    applyDualFitCopy();
    setExtraNote("");
    const dualNote = $("gt-result-dual-note");
    if (dualNote) {
      dualNote.hidden = true;
      dualNote.innerHTML = "";
    }
    const singleTitle = $("gt-result-single-title");
    if (singleTitle) singleTitle.textContent = "Tu talla ideal es";
    const checkMsg = $("gt-mensaje-dinamico-comprobacion");
    if (checkMsg) checkMsg.hidden = true;
    showStep(1);
    clearTableHighlight();
  }

  function clearTableHighlight() {
    document.querySelectorAll(".gt-tabla tr[data-talla]").forEach((row) => {
      row.classList.remove("gt-highlight");
    });
    document.querySelectorAll(".gt-tabla tbody td").forEach((td) => {
      td.style.backgroundColor = "";
      td.style.fontWeight = "";
    });
  }

  function highlightTable(tallas) {
    clearTableHighlight();
    document.querySelectorAll(".gt-tabla tr[data-talla]").forEach((row) => {
      row.classList.toggle("gt-highlight", tallas.includes(row.getAttribute("data-talla")));
    });
  }

  function highlightTableColumn(talla) {
    clearTableHighlight();
    const ths = Array.from(document.querySelectorAll("#guia-tallas-modal .gt-tabla thead th"));
    const colIndex = ths.findIndex((th) => th.textContent.trim() === talla);
    if (colIndex === -1) return;
    document.querySelectorAll("#guia-tallas-modal .gt-tabla tbody tr").forEach((row) => {
      const cell = row.children[colIndex];
      if (cell) {
        cell.style.backgroundColor = "#f5f5f7";
        cell.style.fontWeight = "700";
      }
    });
  }

  function applyHighlight(size) {
    const mode = state.config.highlightMode || (state.tipo === "camisa ss" ? "column" : "row");
    if (mode === "column") highlightTableColumn(size);
    else highlightTable([size]);
  }

  function validateStep1() {
    const h = parseFloat($("gt-altura")?.value);
    const p = parseFloat($("gt-peso")?.value);
    const err = $("gt-error");
    if (!h || !p || h < 100 || p < 30) {
      if (err) {
        err.textContent = "Por favor, introduce altura y peso válidos.";
        err.classList.add("is-visible");
      }
      return false;
    }
    err?.classList.remove("is-visible");
    return true;
  }

  function getComplexion() {
    const checked = document.querySelector('input[data-name="gt-complexion"]:checked');
    return checked ? checked.value : "normal";
  }

  function setSelectButtonLabel(size) {
    const btn = $("gt-btn-select-size");
    if (btn && size) btn.textContent = "Seleccionar " + size;
  }

  function calcScore(h, p, rules, complexion) {
    let score = p * 0.7 + h * 0.3;
    const adjust = rules?.complexion_adjust?.[complexion];
    if (adjust != null) score += adjust;
    return score;
  }

  function sizeFromRanges(score, ranges, fallback) {
    if (!ranges?.length) return fallback;
    for (const range of ranges) {
      if (score < range.max) return range.size;
    }
    return ranges[ranges.length - 1].size;
  }

  function matchesConditionalRule(rule, h, p) {
    if (rule.default) return false;
    if (rule.height_gte != null && h < rule.height_gte) return false;
    if (rule.height_lte != null && h > rule.height_lte) return false;
    if (rule.height_gt != null && h <= rule.height_gt) return false;
    if (rule.height_lt != null && h >= rule.height_lt) return false;
    if (rule.weight_lt != null && p >= rule.weight_lt) return false;
    if (rule.weight_gte != null && p < rule.weight_gte) return false;
    if (rule.weight_lte != null && p > rule.weight_lte) return false;
    if (rule.weight_gt != null && p <= rule.weight_gt) return false;
    return true;
  }

  function matchesPriorityRule(rule, h, p, score) {
    if (rule.weight_gte != null && p < rule.weight_gte) return false;
    if (rule.height_gt != null && h <= rule.height_gt) return false;
    if (rule.weight_gt != null && p <= rule.weight_gt) return false;
    if (rule.height_gte != null && h < rule.height_gte) return false;
    if (rule.weight_lt != null && p >= rule.weight_lt) return false;
    if (rule.score_gte != null && score < rule.score_gte) return false;
    if (rule.score_lt != null && score >= rule.score_lt) return false;
    return true;
  }

  function formatNoteTemplate(template, vars) {
    if (!template) return "";
    return template
      .replace(/\{\{height\}\}/g, String(vars.height))
      .replace(/\{\{weight\}\}/g, String(vars.weight))
      .replace(/\{\{size\}\}/g, String(vars.size))
      .replace(/\{\{suggested_size\}\}/g, String(vars.suggestedSize || ""))
      .replace(/\{\{garment_name\}\}/g, String(vars.garmentName || ""))
      .replace(/\{\{complexion_text\}\}/g, vars.complexionText || "");
  }

  function getGarmentName(tipo, rules) {
    if (rules?.garment_name) return rules.garment_name;
    if (tipo === "chimp") return "chaqueta Chimp";
    if (tipo === "sudadera") return "sudadera";
    if (tipo === "polo") return "tu polo";
    if (tipo === "camisas polo" || tipo === "camisa polo") return "tu camisa polo";
    if (tipo === "camisa ss") return "tu camisa";
    return "tu prenda";
  }

  function getFavoriteGarmentLabel(tipo) {
    if (tipo === "sudadera" || tipo === "chimp") return "sudadera favorita";
    if (tipo === "camisa ss" || tipo === "camisas polo" || tipo === "camisa polo") return "camisa favorita";
    if (tipo === "polo") return "polo favorito";
    return "camiseta favorita";
  }

  function calcScoreRangesDual(rules, h, p, complexion) {
    let score = calcScore(h, p, rules, complexion);
    let tallaRegular = sizeFromRanges(score, rules.ranges, "M");
    const orden = rules.size_order || ["XS", "S", "M", "L", "XL", "XXL"];
    const offset = rules.relaxed_offset != null ? rules.relaxed_offset : 1;
    const regularIndex = Math.max(orden.indexOf(tallaRegular), 0);
    let tallaHolgada = orden[Math.min(regularIndex + offset, orden.length - 1)];
    let specialApplied = false;

    for (const special of rules.special_rules || []) {
      if (matchesConditionalRule(special, h, p)) {
        if (special.regular) tallaRegular = special.regular;
        if (special.relaxed) tallaHolgada = special.relaxed;
        specialApplied = true;
      }
    }

    return { regular: tallaRegular, relaxed: tallaHolgada, specialApplied };
  }

  function calcConditionalRules(rules, h, p) {
    let matchedMeta = null;
    for (const rule of rules.rules || []) {
      if (rule.default) continue;
      if (matchesConditionalRule(rule, h, p)) {
        matchedMeta = rule;
        break;
      }
    }
    if (!matchedMeta) {
      matchedMeta = (rules.rules || []).find((rule) => rule.default) || { size: "L" };
    }
    return {
      size: matchedMeta.size || "L",
      flag: matchedMeta.flag || null,
      note_template: matchedMeta.note_template || null,
      title: matchedMeta.title || null,
    };
  }

  function calcScoreRangesSingle(rules, h, p, complexion) {
    const score = calcScore(h, p, rules, complexion);
    for (const rule of rules.priority_rules || []) {
      if (matchesPriorityRule(rule, h, p, score)) return rule.size;
    }
    for (const rule of rules.advanced_rules || []) {
      if (matchesPriorityRule(rule, h, p, score)) return rule.size;
    }
    return sizeFromRanges(score, rules.ranges, "M");
  }

  function suggestLargerSize(size, sizeOrder, offset) {
    const orden = sizeOrder || [];
    const idx = orden.indexOf(size);
    if (idx < 0) return size;
    const step = offset != null ? offset : 1;
    return orden[Math.min(idx + step, orden.length - 1)];
  }

  function matchesLengthAdvice(advice, h, p) {
    if (!advice) return false;
    return matchesConditionalRule(advice, h, p);
  }

  function getComplexionText(rules, complexion) {
    return rules?.complexion_text_map?.[complexion] || (complexion === "robusto" ? " y complexión robusta" : "");
  }

  function setExtraNote(html) {
    const el = $("gt-result-extra-note");
    if (!el) return;
    if (!html) {
      el.hidden = true;
      el.innerHTML = "";
      return;
    }
    el.hidden = false;
    el.innerHTML = html;
  }

  function setCheckMessage(tipo) {
    const el = $("gt-mensaje-dinamico-comprobacion");
    if (!el) return;
    const label = getFavoriteGarmentLabel(tipo);
    el.hidden = false;
    el.textContent =
      "Esta es la talla que creemos que te va a ir mejor, pero si quieres estar seguro mira las medidas de las tallas más abajo y compruébalas con tu " +
      label +
      ".";
  }

  function buildLengthAdviceHtml(advice, h, p, size, tipo, rules) {
    if (!matchesLengthAdvice(advice, h, p)) return "";
    // Live always shows this warning when height/weight match, even if suggested size equals base size (e.g. already XL).
    const suggested =
      suggestLargerSize(size, advice.size_order || rules.size_order, advice.size_offset) || size;
    const template =
      advice.template_html ||
      "⚠️ RECOMENDACIÓN POR LARGO: Con tus {{height}} cm de estatura, te aconsejamos valorar la talla {{suggested_size}} para asegurar que el largo de torso sea óptimo y {{garment_name}} no te quede corta.";
    const text = formatNoteTemplate(template, {
      height: h,
      weight: p,
      size,
      suggestedSize: suggested,
      garmentName: getGarmentName(tipo, rules),
    });
    return "<br><br><span class=\"gt-length-warn\">" + text + "</span>";
  }

  function buildLegacySingleNote(h, p, size, complexion, tipo, extras) {
    extras = extras || {};
    if (tipo === "sudadera" || tipo === "chimp") {
      const nombre = tipo === "chimp" ? "chaqueta Chimp" : "sudadera";
      if (extras.extremeTall) {
        return (
          "Con una estatura extrema de " +
          h +
          " cm y un perfil delgado de " +
          p +
          " kg, te sugerimos elegir la talla " +
          size +
          " para asegurar el largo óptimo en las mangas y torso de tu " +
          nombre +
          "."
        );
      }
      return (
        "Con " + h + " cm y " + p + " kg, tu talla ideal recomendada es la " + size + " para tu " + nombre + "."
      );
    }

    let txt = "Con " + h + " cm, " + p + " kg";
    if (complexion === "robusto") txt += " y complexión robusta";
    if (tipo === "camisa ss") {
      txt +=
        ", tu talla recomendada por peso es la " +
        size +
        ". Ten en cuenta que está diseñada para encoger un poco en el ancho (pecho) tras el primer lavado.";
    } else {
      txt += ", tu talla recomendada por peso es la " + size + ".";
    }
    return txt;
  }

  function buildResultNote(h, p, size, complexion, tipo, options) {
    options = options || {};
    const rules = state.config.recommendationRules || {};
    const template = options.noteTemplate || state.config.resultNoteTemplate;
    let note;
    if (template) {
      note = formatNoteTemplate(template, {
        height: h,
        weight: p,
        size,
        complexionText: getComplexionText(rules, complexion),
        garmentName: getGarmentName(tipo, rules),
      });
    } else {
      note = buildLegacySingleNote(h, p, size, complexion, tipo, options);
    }

    const adviceHtml = buildLengthAdviceHtml(rules.length_advice, h, p, size, tipo, rules);
    if (adviceHtml) {
      return note + adviceHtml;
    }
    if (options.lengthAdviceHtml) return note + options.lengthAdviceHtml;
    return note;
  }

  function applyProfileTexts() {
    const regularText = state.config.fitCardRegularText;
    const relaxedText = state.config.fitCardRelaxedText;
    const regularEl = $("gt-fit-text-regular");
    const relaxedEl = $("gt-fit-text-relaxed");
    if (regularText && regularEl) regularEl.textContent = regularText;
    if (relaxedText && relaxedEl) relaxedEl.textContent = relaxedText;
  }

  function applyDualFitCopy(options) {
    options = options || {};
    const regularLabel = $("gt-fit-label-regular");
    const relaxedLabel = $("gt-fit-label-relaxed");
    const regularText = $("gt-fit-text-regular");
    const relaxedText = $("gt-fit-text-relaxed");

    if (regularLabel) {
      regularLabel.textContent = options.regularLabel || state.config.fitCardRegularLabel || "Más justa";
    }
    if (relaxedLabel) {
      relaxedLabel.textContent = options.relaxedLabel || state.config.fitCardRelaxedLabel || "Más suelta";
    }
    if (regularText) {
      regularText.textContent =
        options.regularText || state.config.fitCardRegularText || "Si te gusta más ceñida al cuerpo";
    }
    if (relaxedText) {
      relaxedText.textContent =
        options.relaxedText || state.config.fitCardRelaxedText || "Si te gusta más suelta y holgada";
    }
  }

  function hasCompleteProfileRules() {
    const rules = state.config.recommendationRules;
    if (!rules?.engine) return false;

    if (rules.engine === "score_ranges_dual") {
      return Array.isArray(rules.ranges) && rules.ranges.length > 0;
    }

    if (rules.engine === "conditional_rules") {
      return Array.isArray(rules.rules) && rules.rules.length > 0;
    }

    if (rules.engine === "score_ranges_single") {
      const hasRanges = Array.isArray(rules.ranges) && rules.ranges.length > 0;
      const hasPriority = Array.isArray(rules.priority_rules) && rules.priority_rules.length > 0;
      const hasAdvanced = Array.isArray(rules.advanced_rules) && rules.advanced_rules.length > 0;
      return hasRanges || hasPriority || hasAdvanced;
    }

    return false;
  }

  function showDualResult(regular, relaxed, options) {
    options = options || {};
    state.tallaRegular = regular;
    state.tallaRelgada = relaxed;
    state.selectedFit = "regular";

    const blockDual = $("gt-result-dual");
    const blockSingle = $("gt-result-single");
    if (blockDual) {
      blockDual.hidden = false;
      blockDual.setAttribute("aria-hidden", "false");
    }
    if (blockSingle) {
      blockSingle.hidden = true;
      blockSingle.setAttribute("aria-hidden", "true");
    }

    const elReg = $("gt-fit-size-regular");
    const elHol = $("gt-fit-size-relaxed");
    if (elReg) elReg.textContent = regular;
    if (elHol) elHol.textContent = relaxed;

    applyDualFitCopy(options.fitCopy);

    document.querySelectorAll(".gt-fit-card").forEach((card) => {
      card.classList.toggle("is-selected", card.dataset.fit === "regular");
    });

    const noteEl = $("gt-result-dual-note");
    if (noteEl) {
      if (options.noteHtml) {
        noteEl.hidden = false;
        noteEl.innerHTML = options.noteHtml;
      } else {
        noteEl.hidden = true;
        noteEl.innerHTML = "";
      }
    }

    setExtraNote("");
    setCheckMessage(state.tipo);
    setSelectButtonLabel(regular);
    applyHighlight(regular);
    showStep(3);
  }

  function showSingleResult(size, noteText, options) {
    options = options || {};
    state.tallaUnica = size;
    state.selectedFit = "single";

    const blockDual = $("gt-result-dual");
    const blockSingle = $("gt-result-single");
    if (blockDual) {
      blockDual.hidden = true;
      blockDual.setAttribute("aria-hidden", "true");
    }
    if (blockSingle) {
      blockSingle.hidden = false;
      blockSingle.setAttribute("aria-hidden", "false");
    }

    const titleEl = $("gt-result-single-title");
    if (titleEl) {
      titleEl.innerHTML = options.titleHtml || "Tu talla ideal es";
    }

    const sizeEl = $("gt-result-single-size");
    const noteEl = $("gt-result-single-note");
    if (sizeEl) sizeEl.textContent = size;
    if (noteEl) {
      if (options.noteAsHtml || (noteText && noteText.indexOf("<") !== -1)) {
        noteEl.innerHTML = noteText || "";
      } else {
        noteEl.textContent = noteText || "";
      }
    }

    setExtraNote(options.extraHtml || "");
    setCheckMessage(state.tipo);
    setSelectButtonLabel(size);
    applyHighlight(size);
    showStep(3);
  }

  function showSingleResultFromLegacy(h, p, complexion, tipo, size, options) {
    showSingleResult(size, buildResultNote(h, p, size, complexion, tipo, options), {
      titleHtml: options && options.titleHtml,
      noteAsHtml: true,
    });
  }

  function calculateFromProfileRules(h, p, complexion) {
    const rules = state.config.recommendationRules;
    if (!rules?.engine) return false;

    if (rules.engine === "score_ranges_dual") {
      const result = calcScoreRangesDual(rules, h, p, complexion);
      let noteHtml = "";
      let fitCopy = null;

      if (result.specialApplied && rules.special_result) {
        const special = rules.special_result;
        fitCopy = {
          regularLabel: special.regular_label,
          relaxedLabel: special.relaxed_label,
          regularText: special.regular_text,
          relaxedText: special.relaxed_text,
        };
        noteHtml = formatNoteTemplate(special.note_template_html || special.note_template || "", {
          height: h,
          weight: p,
          size: result.regular,
          suggestedSize: result.relaxed,
          garmentName: getGarmentName(state.tipo, rules),
          complexionText: getComplexionText(rules, complexion),
        });
      } else {
        noteHtml = formatNoteTemplate(
          rules.result_note_template || state.config.resultNoteTemplate || "",
          {
            height: h,
            weight: p,
            size: result.regular,
            suggestedSize: result.relaxed,
            garmentName: getGarmentName(state.tipo, rules),
            complexionText: getComplexionText(rules, complexion),
          }
        );
      }

      showDualResult(result.regular, result.relaxed, { noteHtml, fitCopy });
      return true;
    }

    if (rules.engine === "conditional_rules") {
      const result = calcConditionalRules(rules, h, p);
      const noteTemplate =
        result.note_template ||
        (result.flag && rules.flag_notes && rules.flag_notes[result.flag]) ||
        state.config.resultNoteTemplate;
      const note = buildResultNote(h, p, result.size, complexion, state.tipo, {
        noteTemplate,
        extremeTall: result.flag === "extreme_tall",
      });
      const titleHtml =
        result.title ||
        (result.flag && rules.flag_titles && rules.flag_titles[result.flag]) ||
        "Tu talla ideal es";
      showSingleResult(result.size, note, { titleHtml, noteAsHtml: true });
      return true;
    }

    if (rules.engine === "score_ranges_single") {
      const size = calcScoreRangesSingle(rules, h, p, complexion);
      const note = buildResultNote(h, p, size, complexion, state.tipo);
      showSingleResult(size, note, { noteAsHtml: true });
      return true;
    }

    return false;
  }

  function renderStep3Camiseta(h, p, complexion) {
    let puntos = p * 0.7 + h * 0.3;
    if (complexion === "normal") puntos -= 5;
    else if (complexion === "robusto") puntos += 5;

    let tallaRegular = "M";
    if (puntos < 93) tallaRegular = "XS";
    else if (puntos < 104) tallaRegular = "S";
    else if (puntos < 113) tallaRegular = "M";
    else if (puntos < 121) tallaRegular = "L";
    else if (puntos < 126) tallaRegular = "XL";
    else tallaRegular = "XXL";

    const orden = ["XS", "S", "M", "L", "XL", "XXL"];
    let tallaHolgada = orden[Math.min(orden.indexOf(tallaRegular) + 1, orden.length - 1)];
    const camisetaPorLargoExtremo = h >= 190 && p < 78;

    if (camisetaPorLargoExtremo) {
      tallaRegular = "M";
      tallaHolgada = "L";
    }

    let noteHtml;
    let fitCopy;
    if (camisetaPorLargoExtremo) {
      fitCopy = {
        regularLabel: "Más justa",
        relaxedLabel: "Más suelta",
        regularText: "Quedará entallada de ancho",
        relaxedText: "Si te gusta más suelta y holgada",
      };
      noteHtml =
        "Con una estatura de <strong>" +
        h +
        " cm</strong> y un perfil delgado de <strong>" +
        p +
        " kg</strong>, la talla <strong>" +
        tallaRegular +
        "</strong> te encajará de ancho si te gusta la ropa ceñida.<br><br><span class=\"gt-length-warn\">⚠️ RECOMENDACIÓN POR LARGO: Te aconsejamos la talla " +
        tallaHolgada +
        " (Más suelta) para asegurar que el largo de torso sea óptimo para tus " +
        h +
        " cm y no te quede corta.</span>";
    } else {
      const txtComplexion = complexion === "robusto" ? " y complexión robusta" : "";
      noteHtml =
        "Con " +
        h +
        " cm, " +
        p +
        " kg" +
        txtComplexion +
        ", elige la " +
        tallaRegular +
        " si buscas que te quede más justa. Si buscas que te quede con un estilo más oversize/holgado, te sugerimos elegir la " +
        tallaHolgada +
        ".";
    }

    showDualResult(tallaRegular, tallaHolgada, { noteHtml, fitCopy });
  }

  function renderStep3Sudadera(h, p, tipo) {
    let final = "L";
    let sudaderaPorLargoExtremo = false;

    if (h >= 190 && h <= 194 && p < 80) final = "L";
    else if (h >= 190 && h <= 194 && p >= 80) final = "XL";
    else if (h >= 195 && p < 85) {
      final = "XL";
      sudaderaPorLargoExtremo = true;
    } else if (p <= 66) final = h >= 170 ? "M" : "S";
    else if (p <= 76) final = "M";
    else if (p <= 89) final = "L";
    else if (p <= 99) final = "XL";
    else final = "XXL";

    showSingleResultFromLegacy(h, p, "normal", tipo, final, {
      extremeTall: sudaderaPorLargoExtremo,
      titleHtml: sudaderaPorLargoExtremo
        ? '<span class="gt-length-warn">Ajuste recomendado por largo de mangas y torso</span>'
        : "Tu talla ideal es",
    });
  }

  function renderStep3Cuello(h, p, complexion, tipo) {
    let puntosPrenda = p * 0.7 + h * 0.3;
    if (complexion === "robusto") puntosPrenda += 4;

    let talla = "M";
    if (p >= 95) talla = "XXL";
    else if (h > 190 && p > 90) talla = "XXL";
    else if (h >= 180) {
      talla = p >= 85 ? (puntosPrenda >= 127 ? "XXL" : "XL") : puntosPrenda < 111 ? "L" : "XL";
    } else if (p >= 85) {
      talla = puntosPrenda >= 127 ? "XXL" : "XL";
    } else if (tipo === "camisa ss") {
      if (puntosPrenda < 88) talla = "XS";
      else if (puntosPrenda < 98) talla = "S";
      else if (puntosPrenda < 107) talla = "M";
      else if (puntosPrenda < 118) talla = "L";
      else talla = "XL";
    } else {
      if (puntosPrenda < 95) talla = "S";
      else if (puntosPrenda < 105) talla = "M";
      else if (puntosPrenda < 118) talla = "L";
      else if (puntosPrenda < 127) talla = "XL";
      else talla = "XXL";
    }

    const nombreVisible =
      tipo === "polo" ? "tu polo" : tipo === "camisas polo" || tipo === "camisa polo" ? "tu camisa polo" : "tu camisa";
    const ordenTallasCuello = tipo === "camisa ss" ? ["XS", "S", "M", "L", "XL"] : ["S", "M", "L", "XL", "XXL"];
    let lengthAdviceHtml = "";
    if (h >= 190 && p < 78) {
      const suggested = suggestLargerSize(talla, ordenTallasCuello, 1);
      lengthAdviceHtml =
        "<br><br><span class=\"gt-length-warn\">⚠️ RECOMENDACIÓN POR LARGO: Con tus " +
        h +
        " cm de estatura, te aconsejamos valorar la talla " +
        suggested +
        " para asegurar que el largo de torso sea óptimo y " +
        nombreVisible +
        " no te quede corta.</span>";
    }

    showSingleResultFromLegacy(h, p, complexion, tipo, talla, {
      lengthAdviceHtml,
      titleHtml: "Tu talla ideal es",
    });
  }

  function calculateWithLegacy(h, p, complexion, tipo) {
    if (tipo === "camiseta") {
      renderStep3Camiseta(h, p, complexion);
      return;
    }
    if (tipo === "sudadera" || tipo === "chimp") {
      renderStep3Sudadera(h, p, tipo);
      return;
    }
    if (["camisa ss", "polo", "camisas polo", "camisa polo"].includes(tipo)) {
      renderStep3Cuello(h, p, complexion, tipo);
    }
  }

  function calculateAndShowResult() {
    const h = parseFloat($("gt-altura")?.value);
    const p = parseFloat($("gt-peso")?.value);
    const complexion = getComplexion();
    const tipo = state.tipo;

    if (hasCompleteProfileRules()) {
      if (calculateFromProfileRules(h, p, complexion)) return;
    }

    calculateWithLegacy(h, p, complexion, tipo);
  }

  function getSelectedSize() {
    if (state.selectedFit === "regular") return state.tallaRegular;
    if (state.selectedFit === "relaxed") return state.tallaRelgada;
    return state.tallaUnica;
  }

  function selectVariantSize(size) {
    if (!size) return;
    const selectors = [
      `input[name="talla"][value="${size}"]`,
      `input[name="Size"][value="${size}"]`,
      `input[name="size"][value="${size}"]`,
      `.pdp-loco__size-option input[value="${size}"]`,
    ];
    for (const sel of selectors) {
      const input = document.querySelector(sel);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        input.dispatchEvent(new Event("input", { bubbles: true }));
        break;
      }
    }
  }

  function bindEvents() {
    document.querySelectorAll(".gt-modal").forEach((modal) => {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) closeModal(modal.id);
      });
    });

    $("gt-btn-step1-next")?.addEventListener("click", () => {
      if (!validateStep1()) return;
      if (state.hasComplexion) showStep(2);
      else calculateAndShowResult();
    });

    $("gt-btn-step2-back")?.addEventListener("click", () => showStep(1));
    $("gt-btn-step2-next")?.addEventListener("click", () => {
      state.complexion = getComplexion();
      calculateAndShowResult();
    });

    $("gt-btn-step3-back")?.addEventListener("click", () => {
      if (state.hasComplexion) showStep(2);
      else showStep(1);
    });

    $("gt-btn-select-size")?.addEventListener("click", () => {
      selectVariantSize(getSelectedSize());
      closeModal("guia-tallas-modal");
    });

    $("gt-link-direct-table")?.addEventListener("click", () => {
      closeModal("guia-tallas-modal");
      openModal("guia-tallas-tabla-modal");
    });

    $("gt-btn-table-close")?.addEventListener("click", () => closeModal("guia-tallas-tabla-modal"));
    $("gt-btn-trad-close")?.addEventListener("click", () => closeModal("guia-tradicional-modal"));

    document.querySelectorAll(".gt-complexion-card").forEach((card) => {
      card.addEventListener("click", () => {
        card.parentElement?.querySelectorAll(".gt-complexion-card").forEach((c) => {
          c.classList.remove("is-selected");
          c.querySelector("input").checked = false;
        });
        card.classList.add("is-selected");
        card.querySelector("input").checked = true;
      });
    });

    document.querySelectorAll(".gt-fit-card").forEach((card) => {
      card.addEventListener("click", () => {
        document.querySelectorAll(".gt-fit-card").forEach((c) => c.classList.remove("is-selected"));
        card.classList.add("is-selected");
        state.selectedFit = card.dataset.fit || "regular";
        const size = state.selectedFit === "relaxed" ? state.tallaRelgada : state.tallaRegular;
        setSelectButtonLabel(size);
        applyHighlight(size);
      });
    });
  }

  function init() {
    portalModalsToBody();

    state.config = getConfig();
    state.tipo = state.config.tipo || "";
    state.hasComplexion = Boolean(state.config.hasComplexion);
    state.totalSteps = state.hasComplexion ? 3 : 2;
    applyProfileTexts();

    const modal = $("guia-tallas-modal");
    if (modal) {
      const segs = modal.querySelector(".gt-progress");
      if (segs) {
        segs.innerHTML = "";
        for (let i = 0; i < state.totalSteps; i++) {
          const seg = document.createElement("span");
          seg.className = "gt-progress__seg";
          segs.appendChild(seg);
        }
      }
      const step2 = modal.querySelector('[data-step="2"]');
      if (step2) step2.hidden = !state.hasComplexion;
    }

    bindEvents();

    openGuiaTallasModal = function () {
      const config = getConfig();
      state.config = config;
      applyProfileTexts();
      if (config.hasApp) {
        resetWizard();
        openModal("guia-tallas-modal");
        return;
      }
      openModal("guia-tradicional-modal");
    };

    window.inyectarYAlzarModalGuiaTallas = openGuiaTallasModal;
    window.inyectarYAlzarModalTallas = function () {
      resetWizard();
      openModal("guia-tallas-modal");
    };

    window.inyectarYAlzarModalTradicional = function () {
      openModal("guia-tradicional-modal");
    };

    window.gtAbrirTablaDirecta = function () {
      openModal("guia-tallas-tabla-modal");
    };

    if (document.documentElement.dataset.gtOpenPending === "true") {
      delete document.documentElement.dataset.gtOpenPending;
      openGuiaTallasModal();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
